<script setup lang="ts">
/* eslint-env vue/setup-compiler-macros */
interface Props {
    description: string;
    loading?: boolean;
}

withDefaults(defineProps<Props>(), {
    loading: false,
});
</script>

<template>
    <div v-if="!loading" class="payments-empty-state">
        <p class="payments-empty-state__title">No payments found</p>
        <p class="payments-empty-state__text">{{ description }}</p>
    </div>
</template>

<style lang="scss" scoped>
.payments-empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 30px;
    text-align: center;
}

.payments-empty-state__title {
    font-family: $font-family-archivo;
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
    color: $black-color;
    margin: 0 0 8px 0;
}

.payments-empty-state__text {
    font-family: $font-family-archivo;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: rgba($black-color, 0.6);
    margin: 0;
}
</style>